module.exports = __webpack_public_path__ + "static/media/Rainfall_Anxious_Trepidatious.f390a43c.gif";